import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RecipeHit } from '../Models/recipe-hit';
import { SearchService } from '../search.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {

  searchTerms: string = '';
  recipeHits: RecipeHit[];

  constructor(
    private httpClient: HttpClient,
    public searchSvc: SearchService,
    public router: Router,
    public authSvc: AuthService
  ) { }

  ngOnInit() {
    if (this.searchSvc.recipeHits.length > 0) {
      this.recipeHits = this.searchSvc.recipeHits;
    }
  }

  loading = false;

  keydown(e) {
    if (e.keyCode == 13) {
      this.search();
    }
  }

  search() {
    this.loading = true;
    this.recipeHits = [];

    const url = environment.apiUrl + '/search?searchterms=' + this.searchTerms + '&cookbook=' + this.searchSvc.currentCookbook;

    this.httpClient.get(url).subscribe((result: any[]) => {
      this.loading = false;
      this.recipeHits = result;

      // archive the hits in case they back out of the recipe
      this.searchSvc.recipeHits = result;
    });
  }

  newRecipe() {
    this.router.navigate(['/edit-recipe', -1])
  }
}
